module.exports = __webpack_public_path__ + "img/part4.1768119790257.png";